import { NavBar } from "components";
import styled from 'styled-components';

const StyledBaseLayout = styled.div`
  // Getting the viewport maxxed on mobile
  height: 100vh;
  max-height: -webkit-fill-available;
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  pointer-events: none;
`;  

const FrameChildren = styled.div`
  // Mysterious settings to get it to work
  height: 100%;
  // box-sizing: border-box;
  overflow: hidden;
  // Show above tsparticles
  z-index:1;
  pointer-events: none;
`;

const BaseLayout = ( {children, toggleTheme, isDarkMode} ) => {

  return (
    <StyledBaseLayout>
      <NavBar toggleTheme={toggleTheme} isDarkMode={isDarkMode}/>
      <FrameChildren>{ children }</FrameChildren>
    </StyledBaseLayout>
  )
}

export default BaseLayout;
